import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import TablePagination from 'components/table-component-new/TablePagination';

const ClientPagination = ({ data = [], onChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [displayEntries, setDisplayEntries] = useState(10);

  const totalRecords = data.length;

  useEffect(() => {
    setCurrentPage(1);
  }, [displayEntries]);

  useEffect(() => {
    setCurrentPage(1);
  }, [data?.length]);

  const paginatedDataList = useMemo(() => {
    const start = (currentPage - 1) * displayEntries;
    const end = start + displayEntries;
    return data.slice(start, end);
  }, [data, currentPage, displayEntries]);

  useEffect(() => {
    onChange?.({
      paginatedDataList,
      currentPage,
      displayEntries,
      totalRecords,
    });
  }, [paginatedDataList, currentPage, displayEntries, totalRecords, onChange]);

  return (
    <TablePagination
      totalRecords={totalRecords}
      currentPageRecords={paginatedDataList.length}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      displayEntries={displayEntries}
      setDisplayEntries={setDisplayEntries}
      listingFunction={() => {}}
    />
  );
};

ClientPagination.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ClientPagination;
